import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators.edit', {
        url: '/edit/:companyUserId',
        component: 'editAdministrator',
        resolve: {
            administrator,
            companyUserId,
        },
    });
}

/** @ngInject */
function administrator(administrators, companyUserId) {
    return administrators.find(({id}) => id === companyUserId);
}

/** @ngInject */
function companyUserId($stateParams) {
    return $stateParams.companyUserId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/edit/edit-administrator.state.js